import React from 'react';
import { APP_CONFIG } from '../config/constants';

export const PartnersSection: React.FC = () => {
  return (
    <>
      {/* Bande blanche avec logos uniquement */}
      <section className="bg-white py-6 w-full">
        <div className="flex items-center justify-center gap-8 px-6">
          {/* Logo AEHEG - Cliquable */}
          <a 
            href={APP_CONFIG.partners.aeheg.url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center hover:opacity-70 transition-opacity"
            title={APP_CONFIG.partners.aeheg.fullName}
          >
            <img 
              src="/aeheg-logo.png" 
              alt="Association des Étudiant-es HEG"
              className="h-6 w-auto object-contain"
            />
          </a>
          
          {/* Séparateur */}
          <div className="h-6 w-px bg-gray-200"></div>
          
          {/* Logo HEG - Cliquable */}
          <a 
            href={APP_CONFIG.partners.heg.url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center hover:opacity-70 transition-opacity"
            title={APP_CONFIG.partners.heg.fullName}
          >
            <img 
              src="/heg-logo.svg" 
              alt="Haute école de gestion de Genève"
              className="h-6 w-auto object-contain"
            />
          </a>
          
          {/* Séparateur */}
          <div className="h-6 w-px bg-gray-200"></div>
          
          {/* Logo HES-SO - Cliquable */}
          <a 
            href={APP_CONFIG.partners.hesso.url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center hover:opacity-70 transition-opacity"
            title={APP_CONFIG.partners.hesso.fullName}
          >
            <img 
              src="/hessologoclaire.png" 
              alt="HES-SO Genève"
              className="h-6 w-auto object-contain"
            />
          </a>
        </div>
      </section>
    </>
  );
};
